var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0_110_239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_239",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_239",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_239",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACnElEQVR4nO2ZMYtTQRSFHxauWqwozBVB2GaraYW5WwhWyjaW2yg4U9ntb1jLWCmIoP4ESwvx71hkLRS0sjQywcKFNftecmfmvLzzweuSk5wvk5l3k64jhBBCCCGEEEIIIUtu3312TUJ8Ixp/iqbFf65TCXG2f3i80/r9jhan8e0KwWevkD5R9lqcXHIh/eotWim7nmil7PJbh1L22tw5OLoqGl+Lph+U3Qjvjy67ED+uFh4/792PV1q9x62BsitC2RXZPzzeyXvyWgcnB58SKzv1uLj6L8RTdj08ZdfDU3btAzLOlofcJrI5+NjgeXtYD0/Z9fBTlp3Li6YXK/fZEOd5L86PRRh8nKbvLsRXN8OT3aGv7zQ+71rw9zDreWjFGdCUmYV/ceHpw0F9l89rIHvgHcNXvNvD5fXh+r3HN3r2NV00vRlaqjPEWPbprYP0aFDfmrJbii4g+8LVXWo7hBdtOvj02LvPf3yFPRtB9BBE04Ms0vAbUGdlj010Jt/WOU3vRNPv0cgeo+iiq7uUbCvRvvLgc2Z1h/TeanUX26+tREuDwedf8uG36eoueigaip4PED0vuHe/dBq/QUk2Fa02OaU5/4NPJ21eeEqiQwXJ3dRFh0qSJy06VJQ8WdGhsuQpinbNfvgHE+0bDT6TEy2NB5/piNY2//hMUfTCIgcONEFC0YmiNwFNkFB0ouhNQBMkFJ1GJRpu8EETJNs6+MAJ0i0dfAAFLZByzEArJmA5ZqAVE7AcM9CKCViOGWjFBCzHDLRiApZjBloxAcsxA62YgOWYgVZMwHLMQCsmYDlmoBUTsBwz0IoJWI4ZaMUELMcMtGIClmMGWjEByzEDrZiA5ZiBVkzAcsxAKyZgOYQQQgghhBBCCCHdlvIHrNsqQggTlA8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/Decrease.cb4fd255dd7b25e41549cb107ff3b7f5.svg";
export { ForwardRef as ReactComponent };